import { makeVar } from '@apollo/client';

import { EcpMapUserLocation, TFiltersData } from '../../models';
import { IEcpStore, TEcpLocatorResponse } from '../../rest/ecp-locator';
import {
  DEFAULT_CENTER,
  DEFAULT_FILTERS,
  DEFAULT_FILTERS_EXTERNAL,
} from '../../constants/ecp-locator';
import { SortingTypes } from '../../components/business/app/ecp-locator/ecp-sort/ecp-sort.models';

export const setStoreDetail = makeVar<IEcpStore | null>(null);
export const ecpStoresCached = makeVar<TEcpLocatorResponse>([]);
export const setMarkerCode = makeVar<string>('');
export const sortingType = makeVar<SortingTypes>(SortingTypes.distance);
export const setStoreCode = makeVar<string>('');
export const setUserLocation = makeVar<EcpMapUserLocation>(DEFAULT_CENTER);
export const setAutocompletedSearch = makeVar<boolean>(false);
export const setAutocompletedValue = makeVar<string>('');
export const setAutoValueSelected = makeVar<boolean>(false);
export const setEcpFormSubmitted = makeVar<boolean>(false);
export const filterParams = makeVar<TFiltersData>(DEFAULT_FILTERS);
export const filterParamsExternal = makeVar<TFiltersData>(DEFAULT_FILTERS_EXTERNAL);
export const setError = makeVar<string>('');
export const setStopSearch = makeVar<boolean>(false);
export const setExternalSource = makeVar<string>('');
export const pinnedStoreCode = makeVar<string>('');
export const setGeoLocationReady = makeVar<boolean>(false);
export const setNoLocationSearchReady = makeVar<boolean>(false);

export type SearchBounds = [[number, number], [number, number]] | null;
export const setSearchBounds = makeVar<SearchBounds>(null);

// External Ecp Locator
export const sortingTypeExt = makeVar<SortingTypes>(SortingTypes.rating);
